import { } from "helpers/url_helper";
import {
  GET_ORGANIZATION_DETAILS,
  GET_ORGANIZATION_DETAILS_SUCCESS,
  GET_ORGANIZATION_DETAILS_FAIL,
  GET_SUBSCRIPTION_DETAILS,
  GET_SUBSCRIPTION_DETAILS_SUCCESS,
  GET_SUBSCRIPTION_DETAILS_FAIL,
  GET_ROLES,
  GET_ROLES_SUCCESS,
  GET_ROLES_FAIL,
  UPDATE_ROLES,
  UPDATE_ROLES_SUCCESS,
  UPDATE_ROLES_FAIL,
  GET_USERS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  INVITE_USER,
  INVITE_USER_FAIL,
  INVITE_USER_SUCCESS,
  DELETE_USER,
  DELETE_USER_FAIL,
  DELETE_USER_SUCCESS,
  UPDATE_USER,
  UPDATE_USER_FAIL,
  UPDATE_USER_SUCCESS,
  UPDATE_BILLING_DETAILS,
  UPDATE_BILLING_DETAILS_SUCCESS,
  UPDATE_BILLING_DETAILS_FAIL,
  CREATE_BLUEJAY_TEAM,
  CREATE_BLUEJAY_TEAM_SUCCESS,
  CREATE_BLUEJAY_TEAM_FAIL,
  GET_BLUEJAY_TEAM,
  GET_BLUEJAY_TEAM_SUCCESS,
  GET_BLUEJAY_TEAM_FAIL,
  DELETE_BLUEJAY_TEAM,
  DELETE_BLUEJAY_TEAM_SUCCESS,
  DELETE_BLUEJAY_TEAM_FAIL,
  UPDATE_BLUEJAY_TEAM,
  UPDATE_BLUEJAY_TEAM_SUCCESS,
  UPDATE_BLUEJAY_TEAM_FAIL,
  DELETE_SERVICE_FROM_TEAM,
  DELETE_SERVICE_FROM_TEAM_FAIL,
  DELETE_SERVICE_FROM_TEAM_SUCCESS,
  MAP_SERVICES_TO_TEAM,
  MAP_SERVICES_TO_TEAM_SUCCESS,
  MAP_SERVICES_TO_TEAM_FAIL,
  GET_UNMAPPED_TEAM_SERVICES,
  GET_UNMAPPED_TEAM_SERVICES_SUCCESS,
  GET_UNMAPPED_TEAM_SERVICES_FAIL,
  NON_TEAM_USERS,
  NON_TEAM_USERS_FAIL,
  NON_TEAM_USERS_SUCCESS,
  ADD_USERS_TO_TEAM,
  ADD_USERS_TO_TEAM_FAIL,
  ADD_USERS_TO_TEAM_SUCCESS,
  REMOVE_USER_FROM_TEAM,
  REMOVE_USER_FROM_TEAM_FAIL,
  REMOVE_USER_FROM_TEAM_SUCCESS,
  GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS,
  GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS_FAIL,
  GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS_SUCCESS,
  UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS,
  UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS_FAIL,
  UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS_SUCCESS,
  GET_ORG_AWS_SERVICE_LIST_SUCCESS,
  GET_ORG_AWS_SERVICE_LIST,
  GET_ORG_AWS_SERVICE_LIST_FAIL,
  UPDATE_STATUS_ORG_AWS_SERVICE_SUCCESS,
  UPDATE_STATUS_ORG_AWS_SERVICE_FAIL,
  UPDATE_STATUS_ORG_AWS_SERVICE,
  GET_ALLOWED_DOMAINS_RESTRICTIONS,
  GET_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS,
  GET_ALLOWED_DOMAINS_RESTRICTIONS_FAIL,
  DELETE_ALLOWED_DOMAINS_RESTRICTIONS,
  DELETE_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS,
  DELETE_ALLOWED_DOMAINS_RESTRICTIONS_FAIL,
  POST_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS,
  POST_ALLOWED_DOMAINS_RESTRICTIONS_FAIL,
  POST_ALLOWED_DOMAINS_RESTRICTIONS,
  GET_SSO_ONLY_LOGIN_SUCCESS,
  GET_SSO_ONLY_LOGIN_FAIL,
  GET_SSO_ONLY_LOGIN,
  TOGGLE_SSO_ONLY_LOGIN,
  TOGGLE_SSO_ONLY_LOGIN_SUCCESS,
  TOGGLE_SSO_ONLY_LOGIN_FAIL,
  GET_ALERT_DEPLOYMENT_COUNT,
  GET_ALERT_DEPLOYMENT_COUNT_FAIL,
  GET_ALERT_DEPLOYMENT_COUNT_SUCCESS,
  GET_DAILY_RESOURCE_COUNT,
  GET_DAILY_RESOURCE_COUNT_FAIL,
  GET_DAILY_RESOURCE_COUNT_SUCCESS,
  GET_MONTHLY_RESOURCE_COUNT,
  GET_MONTHLY_RESOURCE_COUNT_FAIL,
  GET_MONTHLY_RESOURCE_COUNT_SUCCESS,
  GET_RESOURCE_SCAN_COUNT,
  GET_RESOURCE_SCAN_COUNT_FAIL,
  GET_RESOURCE_SCAN_COUNT_SUCCESS,
  UPDATE_TWO_FACTOR_ORG_ENABLED,
  UPDATE_TWO_FACTOR_ORG_ENABLED_SUCCESS,
  UPDATE_TWO_FACTOR_ORG_ENABLED_FAIL,
  GET_RESOURCE_MAPPING_CONFIG,
  POST_RESOURCE_MAPPING_CONFIG,
  DELETE_RESOURCE_MAPPING_CONFIG,
  UPDATE_RESOURCE_MAPPING_CONFIG,
  GET_RESOURCE_MAPPING_CONFIG_SUCCESS,
  GET_RESOURCE_MAPPING_CONFIG_FAIL,
  POST_RESOURCE_MAPPING_CONFIG_SUCCESS,
  POST_RESOURCE_MAPPING_CONFIG_FAIL,
  DELETE_RESOURCE_MAPPING_CONFIG_FAIL,
  DELETE_RESOURCE_MAPPING_CONFIG_SUCCESS,
  UPDATE_RESOURCE_MAPPING_CONFIG_SUCCESS,
  UPDATE_RESOURCE_MAPPING_CONFIG_FAIL,
  GET_DELETED_USERS,
  GET_DELETED_USERS_SUCCESS,
  GET_DELETED_USERS_FAIL,
  GET_PAGINATED_USERS,
  GET_PAGINATED_USERS_SUCCESS,
  GET_PAGINATED_USERS_FAIL,
  GET_USERS_COUNT,
  GET_USERS_COUNT_SUCCESS,
  GET_USERS_COUNT_FAIL,
  GET_SUGGESTED_MAPPINGS,
  GET_SUGGESTED_MAPPINGS_SUCCESS,
  GET_SUGGESTED_MAPPINGS_FAIL,
  POST_UPDATE_SUGGESTED_MAPPINGS,
  POST_UPDATE_SUGGESTED_MAPPINGS_SUCCESS,
  POST_UPDATE_SUGGESTED_MAPPINGS_FAIL,
  TOGGLE_PUBLISH_STATUS_PAGE,
  TOGGLE_PUBLISH_STATUS_PAGE_SUCCESS,
  TOGGLE_PUBLISH_STATUS_PAGE_FAIL,
  SET_ORG_MAINTENANCE_WINDOW_SUCCESS,
  SET_ORG_MAINTENANCE_WINDOW_FAIL,
  SET_ORG_MAINTENANCE_WINDOW,
  POST_EXTERNAL_PAGES_DETAILS_FAIL,
  POST_EXTERNAL_PAGES_DETAILS_SUCCESS,
  POST_EXTERNAL_PAGES_DETAILS,
  CREATE_CHANGE_EVENT_WEBHOOK,
  CREATE_CHANGE_EVENT_WEBHOOK_SUCCESS,
  CREATE_CHANGE_EVENT_WEBHOOK_FAIL,
  RESET_CREATE_EVENT_WEBHOOK,
  GET_CHANGE_EVENT_WEBHOOKS,
  GET_CHANGE_EVENT_WEBHOOKS_SUCCESS,
  GET_CHANGE_EVENT_WEBHOOKS_FAIL,
  GET_CHANGE_EVENTS,
  GET_CHANGE_EVENTS_SUCCESS,
  GET_CHANGE_EVENTS_FAIL,
  GET_CHANGE_EVENT_BY_ID,
  GET_CHANGE_EVENT_BY_ID_SUCCESS,
  GET_CHANGE_EVENT_BY_ID_FAIL,
  CREATE_OKTA_SSO_INTEGRATION,
  CREATE_OKTA_SSO_INTEGRATION_SUCCESS,
  CREATE_OKTA_SSO_INTEGRATION_FAIL,
  GET_OKTA_SSO_INTEGRATION,
  GET_OKTA_SSO_INTEGRATION_SUCCESS,
  GET_OKTA_SSO_INTEGRATION_FAIL, APPLY_MAPPING_CONFIG, APPLY_MAPPING_CONFIG_SUCCESS, APPLY_MAPPING_CONFIG_FAIL,
  GET_RECENT_CHANGE_EVENTS,GET_RECENT_CHANGE_EVENTS_SUCCESS,GET_RECENT_CHANGE_EVENTS_FAIL

} from "./actionTypes";
import { error } from "toastr";
import {SET_MAINTENANCE_WINDOW_BY_ID, SET_MAINTENANCE_WINDOW_BY_ID_FAIL, SET_MAINTENANCE_WINDOW_BY_ID_SUCCESS} from "../service/actionTypes";

export const getOrganization = () => ({
  type: GET_ORGANIZATION_DETAILS,
})

export const getOrganizationSuccess = organizationDetails => ({
  type: GET_ORGANIZATION_DETAILS_SUCCESS,
  payload: organizationDetails,
})

export const getOrganizationFail = error => ({
  type: GET_ORGANIZATION_DETAILS_FAIL,
  payload: error,
})

export const toggleSsoOnlyLogin = () => ({
    type: TOGGLE_SSO_ONLY_LOGIN,
})

export const toggleSsoOnlyLoginSuccess = ssoOnlyLogin => ({
    type: TOGGLE_SSO_ONLY_LOGIN_SUCCESS,
    payload: ssoOnlyLogin,
})

export const toggleSsoOnlyLoginFail = error => ({
    type: TOGGLE_SSO_ONLY_LOGIN_FAIL,
    payload: error,
})

export const getSsoOnlyLogin = () => ({
    type: GET_SSO_ONLY_LOGIN,
})

export const getSsoOnlyLoginSuccess = ssoOnlyLogin => ({
    type: GET_SSO_ONLY_LOGIN_SUCCESS,
    payload: ssoOnlyLogin,
})

export const getSsoOnlyLoginFail = error => ({
    type: GET_SSO_ONLY_LOGIN_FAIL,
    payload: error,
})

export const getSubscription = () => ({
  type: GET_SUBSCRIPTION_DETAILS,
})

export const getSubscriptionSuccess = subscriptionDetails => ({
  type: GET_SUBSCRIPTION_DETAILS_SUCCESS,
  payload: subscriptionDetails,
})

export const getSubscriptionFail = error => ({
  type: GET_SUBSCRIPTION_DETAILS_FAIL,
  payload: error,
})

export const getAllowedDomainsRestrictions = () => ({
    type: GET_ALLOWED_DOMAINS_RESTRICTIONS,
})

export const getAllowedDomainsRestrictionsSuccess = domains => ({
    type: GET_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS,
    payload: domains,
})

export const getAllowedDomainsRestrictionsFail = error => ({
    type: GET_ALLOWED_DOMAINS_RESTRICTIONS_FAIL,
    payload: error,
})

export const getUsers = () => ({
  type: GET_USERS,
})

export const getDeletedUsers = () => ({
  type: GET_DELETED_USERS,
})

export const getDeletedUsersSuccess = users => ({
    type: GET_DELETED_USERS_SUCCESS,
    payload: users,
})

export const getDeletedUsersFail = error => ({
    type: GET_DELETED_USERS_FAIL,
    payload: error,
})

export const getUsersSuccess = users => ({
  type: GET_USERS_SUCCESS,
  payload: users,
})

export const getUsersFail = error => ({
  type: GET_USERS_FAIL,
  payload: error,
})

export const updateBillingDetails = (name, email, address, city, country, state, zip_code) => {
  return {
    type: UPDATE_BILLING_DETAILS,
    payload: { name, email, address, city, country, state, zip_code },
  }
}

export const updateBillingDetailsSuccess = billingDetails => ({
  type: UPDATE_BILLING_DETAILS_SUCCESS,
  payload: billingDetails,
})

export const updateBillingDetailsFail = error => ({
  type: UPDATE_BILLING_DETAILS_FAIL,
  payload: error,
})

export const inviteUser = (email, name, phone_number, role_id) => {
  return {
    type: INVITE_USER,
    payload: { email, name, phone_number, role_id },
  }
}

export const inviteUserSuccess = users => ({
  type: INVITE_USER_SUCCESS,
  payload: users,
})

export const inviteUserFail = error => ({
  type: INVITE_USER_FAIL,
  payload: error,
})

export const deleteUser = user_id => {
  return {
    type: DELETE_USER,
    payload: { user_id },
  }
}

export const deleteUserSuccess = users => ({
  type: DELETE_USER_SUCCESS,
  payload: users,
})

export const deleteUserFail = error => ({
  type: DELETE_USER_FAIL,
  payload: error,
})

export const updateUser = data => {
  return {
    type: UPDATE_USER,
    payload: data,
  }
}

export const updateUserSuccess = users => ({
  type: UPDATE_USER_SUCCESS,
  payload: users,
})

export const updateUserFail = error => ({
  type: UPDATE_USER_FAIL,
  payload: error,
})

export const getRoles = () => ({
  type: GET_ROLES,
})

export const getRolesSuccess = roles => ({
  type: GET_ROLES_SUCCESS,
  payload: roles,
})

export const getRolesFail = error => ({
  type: GET_ROLES_FAIL,
  payload: error,
})

export const updateRoles = (user_id, role_id) => {
  return {
    type: UPDATE_ROLES,
    payload: { user_id, role_id },
  }
}

export const updateRolesSuccess = roles => ({
  type: UPDATE_ROLES_SUCCESS,
  payload: roles,
})

export const updateRolesFail = error => ({
  type: UPDATE_ROLES_FAIL,
  payload: error,
})

export const createBluejayTeam = (name) => ({
  type: CREATE_BLUEJAY_TEAM,
  payload: { name },
})

export const createBluejayTeamSuccess = team => ({
  type: CREATE_BLUEJAY_TEAM_SUCCESS,
  payload: team,
})

export const createBluejayTeamFail = error => ({
  type: CREATE_BLUEJAY_TEAM_FAIL,
  payload: error,
})

export const getBluejayTeam = () => ({
  type: GET_BLUEJAY_TEAM,
})

export const getBluejayTeamSuccess = team => ({
  type: GET_BLUEJAY_TEAM_SUCCESS,
  payload: team,
})

export const getBluejayTeamFail = error => ({
  type: GET_BLUEJAY_TEAM_FAIL,
  payload: error,
})

export const deleteBluejayTeam = (team_id) => ({
  type: DELETE_BLUEJAY_TEAM,
  payload: { team_id },
})

export const deleteBluejayTeamSuccess = team => ({
  type: DELETE_BLUEJAY_TEAM_SUCCESS,
  payload: team,
})

export const deleteBluejayTeamFail = error => ({
  type: DELETE_BLUEJAY_TEAM_FAIL,
  payload: error,
})

export const updateBluejayTeam = (team_id, name) => ({
  type: UPDATE_BLUEJAY_TEAM,
  payload: { team_id, name },
})

export const updateBluejayTeamSuccess = team => ({
  type: UPDATE_BLUEJAY_TEAM_SUCCESS,
  payload: team,
})

export const updateBluejayTeamFail = error => ({
  type: UPDATE_BLUEJAY_TEAM_FAIL,
  payload: error,
})

export const postAllowedDomainsRestrictions = (domain) => ({
    type: POST_ALLOWED_DOMAINS_RESTRICTIONS,
    payload: { domain },
})

export const postAllowedDomainsRestrictionsSuccess = domain => ({
    type: POST_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS,
    payload: domain,
})

export const postAllowedDomainsRestrictionsFail = error => ({
    type: POST_ALLOWED_DOMAINS_RESTRICTIONS_FAIL,
    payload: error,
})

export const deleteAllowedDomainsRestrictions = (domain) => ({
  type: DELETE_ALLOWED_DOMAINS_RESTRICTIONS,
  payload: { domain },
})

export const deleteAllowedDomainsRestrictionsSuccess = domain => ({
  type: DELETE_ALLOWED_DOMAINS_RESTRICTIONS_SUCCESS,
  payload: domain,
})

export const deleteAllowedDomainsRestrictionsFail = error => ({
  type: DELETE_ALLOWED_DOMAINS_RESTRICTIONS_FAIL,
  payload: error,
})

export const deleteServiceFromTeam = (service_id) => ({
  type: DELETE_SERVICE_FROM_TEAM,
  payload: { service_id },
})

export const deleteServiceFromTeamSuccess = team => ({
  type: DELETE_SERVICE_FROM_TEAM_SUCCESS,
  payload: team,
})

export const deleteServiceFromTeamFail = error => ({
  type: DELETE_SERVICE_FROM_TEAM_FAIL,
  payload: error,
})

export const getUnmappedTeamServices = (team_id) => ({
  type: GET_UNMAPPED_TEAM_SERVICES,
  payload: { team_id },
})

export const getUnmappedTeamServicesSuccess = services => ({
  type: GET_UNMAPPED_TEAM_SERVICES_SUCCESS,
  payload: services,
})

export const getUnmappedTeamServicesFail = error => ({
  type: GET_UNMAPPED_TEAM_SERVICES_FAIL,
  payload: error,
})

export const mapServicesToTeam = (team_id, service_ids) => ({
  type: MAP_SERVICES_TO_TEAM,
  payload: { team_id, service_ids },
})

export const mapServicesToTeamSuccess = team => ({
  type: MAP_SERVICES_TO_TEAM_SUCCESS,
  payload: team,
})

export const mapServicesToTeamFail = error => ({
  type: MAP_SERVICES_TO_TEAM_FAIL,
  payload: error,
})

export const nonTeamUsers = (team_id) => ({
  type: NON_TEAM_USERS,
  payload: { team_id }
})

export const nonTeamUsersSuccess = users => ({
  type: NON_TEAM_USERS_SUCCESS,
  payload: users,
})

export const nonTeamUsersFail = error => ({
  type: NON_TEAM_USERS_FAIL,
  payload: error,
})

export const addUsersToTeam = (team_id, user_ids) => ({
  type: ADD_USERS_TO_TEAM,
  payload: { team_id, user_ids }
})

export const addUsersToTeamSuccess = users => ({
  type: ADD_USERS_TO_TEAM_SUCCESS,
  payload: users,
})

export const addUsersToTeamFail = error => ({
  type: ADD_USERS_TO_TEAM_FAIL,
  payload: error,
})

export const removeUserFromTeam = (team_id, user_id) => ({
  type: REMOVE_USER_FROM_TEAM,
  payload: { team_id, user_id }
})

export const removeUserFromTeamSuccess = users => ({
  type: REMOVE_USER_FROM_TEAM_SUCCESS,
  payload: users,
})

export const removeUserFromTeamFail = error => ({
  type: REMOVE_USER_FROM_TEAM_FAIL,
  payload: error,
})

export const getOrgPrimaryNotificationChannels = () => ({
  type: GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS,
})

export const getOrgPrimaryNotificationChannelsSuccess = channels => ({
  type: GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS_SUCCESS,
  payload: channels,
})

export const getOrgPrimaryNotificationChannelsFail = error => ({
  type: GET_ORG_PRIMARY_NOTIFICAITON_CHANNELS_FAIL,
  payload: error,
})

export const updateOrgPrimaryNotificationChannels = (id) => ({
  type: UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS,
  payload: { id }
})

export const updateOrgPrimaryNotificationChannelsSuccess = channels => ({
  type: UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS_SUCCESS,
  payload: channels,
})

export const updateOrgPrimaryNotificationChannelsFail = error => ({
  type: UPDATE_ORG_PRIMARY_NOTIFICAITON_CHANNELS_FAIL,
  payload: error,
})

export const getAwsOrgServiceList = () =>({
  type:GET_ORG_AWS_SERVICE_LIST,
})

export const getAwsOrgServiceListSuccess = services => ({
  type:GET_ORG_AWS_SERVICE_LIST_SUCCESS,
  payload: services,
})

export const getAwsOrgServiceListFail = error => ({
  type: GET_ORG_AWS_SERVICE_LIST_FAIL,
  payload: error,
})

export const updateAwsOrgServiceListSuccess = services => ({
  type: UPDATE_STATUS_ORG_AWS_SERVICE_SUCCESS,
  payload: services,
})
export const updateAwsOrgServiceListFail = error => ({
  type: UPDATE_STATUS_ORG_AWS_SERVICE_FAIL,
  payload: error,
})

export const updateAwsOrgServiceList = (services) => ({
  type:UPDATE_STATUS_ORG_AWS_SERVICE,
  payload: {services},
})

export const getAlertDeploymentCount = () => ({
  type: GET_ALERT_DEPLOYMENT_COUNT
})

export const getAlertDeploymentCountSuccess = (alertsCount) => ({
  type: GET_ALERT_DEPLOYMENT_COUNT_SUCCESS,
  payload: {alertsCount}
})

export const getAlertDeploymentCountFail = error => ({
  type: GET_ALERT_DEPLOYMENT_COUNT_FAIL,
  payload: error
})

export const getResourceScanCount = () => ({
  type: GET_RESOURCE_SCAN_COUNT
})

export const getResourceScanCountFail = error => ({
  type: GET_RESOURCE_SCAN_COUNT_FAIL,
  payload: error
})

export const getResourceScanCountSuccess = (resourceScanCount) => ({
  type: GET_RESOURCE_SCAN_COUNT_SUCCESS,
  payload: {resourceScanCount}
})

export const getDailyResourceCount = () => ({
  type: GET_DAILY_RESOURCE_COUNT
})

export const getDailyResourceCountSuccess = (dailyResourceCount) => ({
  type: GET_DAILY_RESOURCE_COUNT_SUCCESS,
  payload: dailyResourceCount
})

export const getDailyResourceCountFail = error => ({
  type: GET_DAILY_RESOURCE_COUNT_FAIL,
  payload: error
})

export const getMonthlyResourceCount = () => ({
  type: GET_MONTHLY_RESOURCE_COUNT
})

export const getMonthlyResourceCountSuccess = (monthlyResourceCount) => ({
  type: GET_MONTHLY_RESOURCE_COUNT_SUCCESS,
  payload: monthlyResourceCount
})

export const getMonthlyResourceCountFail = error => ({
  type: GET_MONTHLY_RESOURCE_COUNT_FAIL,
  payload: error
})

export const updateTwoFactorOrgEnabled = (data) => {
  return {
      type: UPDATE_TWO_FACTOR_ORG_ENABLED,
      payload: { data }
  }
}

export const updateTwoFactorOrgEnabledSucces = (msg) => {
  return {
      type: UPDATE_TWO_FACTOR_ORG_ENABLED_SUCCESS,
      payload: msg
  }
}

export const updateTwoFactorOrgEnabledFail = (error) => {
  return {
      type: UPDATE_TWO_FACTOR_ORG_ENABLED_FAIL,
      payload: error
  }
}

export const getResourceMappingConfig = () => ({
  type: GET_RESOURCE_MAPPING_CONFIG
})

export const getResourceMappingConfigSuccess = (mappedServices) => ({
  type: GET_RESOURCE_MAPPING_CONFIG_SUCCESS,
  payload: mappedServices
})

export const getResourceMappingConfigFail = (error) => ({
  type: GET_RESOURCE_MAPPING_CONFIG_FAIL,
  payload: error
})

export const postResourceMappingConfig = (data) => ({
  type: POST_RESOURCE_MAPPING_CONFIG,
  payload: data
})

export const postResourceMappingConfigSuccess = (data) => ({
  type: POST_RESOURCE_MAPPING_CONFIG_SUCCESS,
  payload: data
})

export const postResourceMappingConfigFail = (error) => ({
  type: POST_RESOURCE_MAPPING_CONFIG_FAIL,
  payload: error
})

export const deleteResourceMappingConfig = (data) => ({
  type: DELETE_RESOURCE_MAPPING_CONFIG,
  payload: data
})

export const deleteResourceMappingConfigSuccess = (response) => ({
  type: DELETE_RESOURCE_MAPPING_CONFIG_SUCCESS,
  payload: response
})

export const deleteResourceMappingConfigFail = (error) => ({
  type: DELETE_RESOURCE_MAPPING_CONFIG_FAIL,
  payload: error
})

export const updateResourceMappingConfig = (data) => ({
  type: UPDATE_RESOURCE_MAPPING_CONFIG,
  payload: data
})

export const updateResourceMappingConfigSuccess = (response) => ({
  type: UPDATE_RESOURCE_MAPPING_CONFIG_SUCCESS,
  payload: response
})

export const updateResourceMappingConfigFail = (error) => ({
  type: UPDATE_RESOURCE_MAPPING_CONFIG_FAIL,
  payload: error
})

export const getPaginatedUsers = (page_filters) => ({
  type: GET_PAGINATED_USERS,
  payload: { page_filters }
});

export const getPaginatedUsersSuccess = (paginatedUsers) => ({
  type: GET_PAGINATED_USERS_SUCCESS,
  payload: paginatedUsers,
});

export const getPaginatedUsersFail = (error) => ({
  type: GET_PAGINATED_USERS_FAIL,
  payload: error,
});


export const getUsersCount = (page_filters) => ({
  type: GET_USERS_COUNT,
  payload: { page_filters },
});

export const getUsersCountSuccess = (userCount) => ({
  type: GET_USERS_COUNT_SUCCESS,
  payload: userCount,
});

export const getUsersCountFail = (error) => ({
  type: GET_USERS_COUNT_FAIL,
  payload: error,
});

export const getSuggestedMappings = () => ({
  type: GET_SUGGESTED_MAPPINGS,
});

export const getSuggestedMappingsSuccess = (data) => ({
  type : GET_SUGGESTED_MAPPINGS_SUCCESS,
  payload: data
});

export const getSuggestedMappingsFail = error => ({
  type: GET_SUGGESTED_MAPPINGS_FAIL,
  payload: error
});

export const postUpdateSuggestedMappings = (data) => ({
  type: POST_UPDATE_SUGGESTED_MAPPINGS,
  payload: data
});

export const postUpdateSuggestedMappingsSuccess = (data) => ({
  type: POST_UPDATE_SUGGESTED_MAPPINGS_SUCCESS,
  payload: data
});

export const postUpdateSuggestedMappingsFail = error => ({
  type: POST_UPDATE_SUGGESTED_MAPPINGS_FAIL,
  payload: error
});


export const togglePublishStatusPage = () => ({
  type: TOGGLE_PUBLISH_STATUS_PAGE,
})

export const togglePublishStatusPageSuccess = publishPage => ({
  type: TOGGLE_PUBLISH_STATUS_PAGE_SUCCESS,
  payload: publishPage,
})

export const togglePublishStatusPageFail = error => ({
  type: TOGGLE_PUBLISH_STATUS_PAGE_FAIL,
  payload: error,
})

export const postSetOrgMaintenance = (data) => ({
  type: SET_ORG_MAINTENANCE_WINDOW,
  payload: data
})

export const postSetOrgMaintenanceSuccess = (data) => ({
  type: SET_ORG_MAINTENANCE_WINDOW_SUCCESS,
  payload: data
})

export const postSetOrgMaintenanceFail = (error) => ({
  type: SET_ORG_MAINTENANCE_WINDOW_FAIL,
  payload: error,
})

export const postExternalPageDetails = (data) => ({
  type: POST_EXTERNAL_PAGES_DETAILS,
  payload: data
})

export const postExternalPageDetialsSuccess = (data) => ({
  type: POST_EXTERNAL_PAGES_DETAILS_SUCCESS,
  payload: data
})

export const postExternalPageDetialsFail = (error) => ({
  type: POST_EXTERNAL_PAGES_DETAILS_FAIL,
  payload: error
})

export const createChangeEventWebhook = (data) => ({
  type: CREATE_CHANGE_EVENT_WEBHOOK,
  payload: data
})

export const createChangeEventWebhookSuccess = (data) => ({
  type: CREATE_CHANGE_EVENT_WEBHOOK_SUCCESS,
  payload: data
})

export const createChangeEventWebhookFail = (error) => ({
  type: CREATE_CHANGE_EVENT_WEBHOOK_FAIL,
  payload: error
})

export const resetCreateEventWebhook = () => ({
  type: 'RESET_CREATE_EVENT_WEBHOOK'
});


export const getChangeEventWebhooks = () => ({
  type: GET_CHANGE_EVENT_WEBHOOKS,
})

export const getChangeEventWebhooksSuccess = (data) => ({
  type: GET_CHANGE_EVENT_WEBHOOKS_SUCCESS,
  payload: data
})

export const getChangeEventWebhooksFail = (error) => ({
  type: GET_CHANGE_EVENT_WEBHOOKS_FAIL,
  payload: error
})

export const getChangeEvents = () => ({
  type: GET_CHANGE_EVENTS,
});

export const getChangeEventsSuccess = (data) => ({
  type: GET_CHANGE_EVENTS_SUCCESS,
  payload: data
});

export const getChangeEventsFail = (error) => ({
  type: GET_CHANGE_EVENTS_FAIL,
  payload: error
});

export const getRecentChangeEvents = (alertId) => ({
  type: GET_RECENT_CHANGE_EVENTS,
  payload: {alertId}
})

export const getRecentChangeEventsSuccess = (data) => ({
  type: GET_RECENT_CHANGE_EVENTS_SUCCESS,
  payload: data
})

export const getRecentChangeEventsFail = (error) => ({
  type: GET_RECENT_CHANGE_EVENTS_FAIL,
  payload: error
})

// Change Event By ID
export const getChangeEventById = (eventId) => ({
  type: GET_CHANGE_EVENT_BY_ID,
  payload: eventId
});

export const getChangeEventByIdSuccess = (data) => ({
  type: GET_CHANGE_EVENT_BY_ID_SUCCESS,
  payload: data
});

export const getChangeEventByIdFail = (error) => ({
  type: GET_CHANGE_EVENT_BY_ID_FAIL,
  payload: error
});

export const postCreateOktaSSOIntegration = (data) => ({
  type: CREATE_OKTA_SSO_INTEGRATION,
  payload: data
})

export const postCreateOktaSSOIntegrationSuccess = (data) => ({
  type: CREATE_OKTA_SSO_INTEGRATION_SUCCESS,
  payload: data
})

export const postCreateOktaSSOIntegrationFail = (error) => ({
  type: CREATE_OKTA_SSO_INTEGRATION_FAIL,
  payload: error
})

export const getOktaSSOIntegration = () => ({
  type:GET_OKTA_SSO_INTEGRATION
})

export const getOktaSSOIntegrationSuccess = (data) => ({
  type: GET_OKTA_SSO_INTEGRATION_SUCCESS,
  payload: data
})

export const getOktaSSOIntegrationFail = (error) => ({
  type: GET_OKTA_SSO_INTEGRATION_FAIL,
  payload: error
})

export const applyMappingConfig = () => ({
  type: APPLY_MAPPING_CONFIG
})

export const applyMappingConfigSuccess = (data) => ({
  type: APPLY_MAPPING_CONFIG_SUCCESS,
  payload: data
})

export const applyMappingFail = (error) => ({
  type: APPLY_MAPPING_CONFIG_FAIL,
  payload: error
})

